export enum IOrganizationWorkingDaysAnalyticsActivityEnum {
  LocalStartTime = 'OrgWorkingDaysActivity.localstarttime',
  FocusPercentage = 'OrgWorkingDaysActivity.focusPercentage',
  DigitalIntensity = 'OrgWorkingDaysActivity.digitalIntensity',
  SessionCallDuration = 'OrgWorkingDaysActivity.sessionCallDuration',
  TotalActivityDuration = 'OrgWorkingDaysActivity.totalActivityDuration',
  TotalFocusDuration = 'OrgWorkingDaysActivity.totalFocusDuration',
  TotalSessionCallDuration = 'OrgWorkingDaysActivity.totalSessionCallDuration',
  UserId = 'OrgWorkingDaysActivity.userid',
  CumulativeDailyAverageScreentime = 'OrgWorkingDaysActivity.cumulativeDailyAverageScreentime',
  CumulativeDailyAverageWorkingHours = 'OrgWorkingDaysActivity.cumulativeDailyAverageWorkingHours',
  CumulativeWeeklyAverageScreentime = 'OrgWorkingDaysActivity.cumulativeDailyAverageScreentime',
  CumulativeWeeklyAverageWorkingHours = 'OrgWorkingDaysActivity.cumulativeDailyAverageWorkingHours',
  WeekCount = 'OrgWorkingDaysActivity.weekCount',
  DayCount = 'OrgWorkingDaysActivity.dayCount',
  CallWeekCount = 'OrgWorkingDaysActivity.callWeekCount',
  CallDayCount = 'OrgWorkingDaysActivity.callDayCount',
  WeekDayIndex = 'OrgWorkingDaysActivity.weekday_index',
  TotalDuration = 'OrgWorkingDaysActivity.totalDuration',
  AppId = 'OrgWorkingDaysActivity.appid',
  TotalCallDuration = 'OrgWorkingDaysActivity.totalCallDuration',
  CallCount = 'OrgWorkingDaysActivity.callCount',
  LocalStartDate = 'OrgWorkingDaysActivity.localstartdate',
  UserCount = 'OrgWorkingDaysActivity.userCount',
  DepartmentId = 'OrgWorkingDaysActivity.departmentid',
}
